/* This file is autogenerated, see readme.md for instructions */
import ClipboardAddSvgIcon from '@bloomreach/banana-theme/icons/clipboard-add.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ClipboardAddIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ClipboardAddSvgIcon />
    </Icon>
  );
});

ClipboardAddIcon.displayName = 'ClipboardAddIcon';

export default ClipboardAddIcon;
